null


// WEBPACK FOOTER //
// ./~/string-replace-loader?{"multiple":[{"search":"$AUTHOR$","replace":"Piotr Kowalski <piecioshka@gmail.com> (https:/piecioshka.pl)"},{"search":"$NAME$","replace":"underscore.assert"},{"search":"$DESCRIPTION$","replace":"🔨 Plugin for Underscore.js: add `_.assert()`, which simplify checking states"},{"search":"$VERSION$","replace":"1.2.8"},{"search":"$LICENSE$","replace":"MIT"}]}!./index.js